module.exports = __webpack_public_path__ + "img/weizhibo-doc.193f23dd.png";